// extracted by mini-css-extract-plugin
export default {"noData":"Table_noData__M3cXh","row":"Table_row__Qwywq","selected":"Table_selected__SS4-Z","paginationContainer":"Table_paginationContainer__O-vyX","skeleton":"Table_skeleton__3Q8lS"};